import { ParameterCategoryView } from 'types/trackmanParameters';
import { TourAverageParameterOption } from 'types/admin/tourAverages';

export const mapCategoriesToParameterOptions = (categories: ParameterCategoryView[]): TourAverageParameterOption[] =>
  categories.flatMap((category) =>
    category.subcategories.flatMap((subcategory) =>
      subcategory.parameters.map((parameter) => ({
        id: parameter.id,
        title: parameter.title,
        categoryLabel: `${category.title} / ${subcategory.title}`,
      }))
    )
  );
